import { render } from "./SaveAccessoryModal.vue?vue&type=template&id=c32f883a"
import script from "./SaveAccessoryModal.vue?vue&type=script&lang=js"
export * from "./SaveAccessoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__